export default __webpack_public_path__ + "static/media/cr1.8cd9a4d9.jpg";